import { css } from 'styled-components';

export const background = (options = {}) => css`
  background: var(--${options.color || 'neutral'}-${options.level || 300});
`;
